"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropListItemContentMediaAudio from "./DropListItemContentMediaAudio";
import { ImageScale } from "@/helpers/image.helpers";
import type { MediaLoadStrategy } from "./mediaLoadStrategy";
import DropListItemContentMediaImage from "./DropListItemContentMediaImage";
import DropListItemContentMediaVideo from "./DropListItemContentMediaVideo";
import MediaDisplay from "./MediaDisplay";
enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  GLB = "GLB",
  HTML = "HTML",
  UNKNOWN = "UNKNOWN",
}
const DropListItemContentMediaGLB = dynamic(() => import("./DropListItemContentMediaGLB"), {
  ssr: false
});
export default function DropListItemContentMedia(t0) {
  const $ = _c(40);
  const {
    media_mime_type,
    media_url,
    onContainerClick,
    isCompetitionDrop: t1,
    disableModal: t2,
    disableAutoPlay: t3,
    imageObjectPosition,
    imageScale: t4,
    htmlIframeContainerClassName,
    htmlPreviewImageUrl,
    loadStrategy: t5
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const disableModal = t2 === undefined ? false : t2;
  const disableAutoPlay = t3 === undefined ? false : t3;
  const imageScale = t4 === undefined ? ImageScale.AUTOx800 : t4;
  const loadStrategy = t5 === undefined ? "in-view" : t5;
  let t6;
  if ($[0] !== media_mime_type || $[1] !== media_url) {
    t6 = () => {
      if (media_mime_type.includes("image")) {
        return MediaType.IMAGE;
      }
      if (media_mime_type.includes("video")) {
        return MediaType.VIDEO;
      }
      if (media_mime_type.includes("audio")) {
        return MediaType.AUDIO;
      }
      if (media_mime_type === "model/gltf-binary" || media_mime_type === "model/gltf+json" || media_url.endsWith(".glb") || media_url.endsWith(".gltf")) {
        return MediaType.GLB;
      }
      if (media_mime_type === "text/html") {
        return MediaType.HTML;
      }
      return MediaType.UNKNOWN;
    };
    $[0] = media_mime_type;
    $[1] = media_url;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const getMediaType = t6;
  let t7;
  if ($[3] !== disableAutoPlay || $[4] !== disableModal || $[5] !== getMediaType || $[6] !== htmlIframeContainerClassName || $[7] !== htmlPreviewImageUrl || $[8] !== imageObjectPosition || $[9] !== imageScale || $[10] !== isCompetitionDrop || $[11] !== loadStrategy || $[12] !== media_mime_type || $[13] !== media_url || $[14] !== onContainerClick) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mediaType = getMediaType();
      switch (mediaType) {
        case MediaType.IMAGE:
          {
            let t8;
            if ($[16] !== disableModal || $[17] !== imageObjectPosition || $[18] !== imageScale || $[19] !== isCompetitionDrop || $[20] !== loadStrategy || $[21] !== media_url || $[22] !== onContainerClick) {
              t8 = <DropListItemContentMediaImage src={media_url} onContainerClick={onContainerClick} isCompetitionDrop={isCompetitionDrop} disableModal={disableModal} imageObjectPosition={imageObjectPosition} imageScale={imageScale} loadStrategy={loadStrategy} />;
              $[16] = disableModal;
              $[17] = imageObjectPosition;
              $[18] = imageScale;
              $[19] = isCompetitionDrop;
              $[20] = loadStrategy;
              $[21] = media_url;
              $[22] = onContainerClick;
              $[23] = t8;
            } else {
              t8 = $[23];
            }
            t7 = t8;
            break bb0;
          }
        case MediaType.VIDEO:
          {
            let t8;
            if ($[24] !== disableAutoPlay || $[25] !== media_url) {
              t8 = <DropListItemContentMediaVideo src={media_url} disableAutoPlay={disableAutoPlay} />;
              $[24] = disableAutoPlay;
              $[25] = media_url;
              $[26] = t8;
            } else {
              t8 = $[26];
            }
            t7 = t8;
            break bb0;
          }
        case MediaType.AUDIO:
          {
            let t8;
            if ($[27] !== media_url) {
              t8 = <DropListItemContentMediaAudio src={media_url} />;
              $[27] = media_url;
              $[28] = t8;
            } else {
              t8 = $[28];
            }
            t7 = t8;
            break bb0;
          }
        case MediaType.GLB:
          {
            let t8;
            if ($[29] !== media_url) {
              t8 = <DropListItemContentMediaGLB src={media_url} />;
              $[29] = media_url;
              $[30] = t8;
            } else {
              t8 = $[30];
            }
            t7 = t8;
            break bb0;
          }
        case MediaType.HTML:
          {
            let t8;
            if ($[31] !== disableAutoPlay || $[32] !== htmlIframeContainerClassName || $[33] !== htmlPreviewImageUrl || $[34] !== imageScale || $[35] !== loadStrategy || $[36] !== media_mime_type || $[37] !== media_url) {
              t8 = <MediaDisplay media_mime_type={media_mime_type} media_url={media_url} imageScale={imageScale} previewImageUrl={htmlPreviewImageUrl} requireInteractionToLoad={disableAutoPlay} iframeContainerClassName={htmlIframeContainerClassName} loadStrategy={loadStrategy} />;
              $[31] = disableAutoPlay;
              $[32] = htmlIframeContainerClassName;
              $[33] = htmlPreviewImageUrl;
              $[34] = imageScale;
              $[35] = loadStrategy;
              $[36] = media_mime_type;
              $[37] = media_url;
              $[38] = t8;
            } else {
              t8 = $[38];
            }
            t7 = t8;
            break bb0;
          }
        case MediaType.UNKNOWN:
          {
            let t8;
            if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
              t8 = <></>;
              $[39] = t8;
            } else {
              t8 = $[39];
            }
            t7 = t8;
            break bb0;
          }
        default:
          {
            t7 = assertUnreachable(mediaType);
            break bb0;
          }
      }
    }
    $[3] = disableAutoPlay;
    $[4] = disableModal;
    $[5] = getMediaType;
    $[6] = htmlIframeContainerClassName;
    $[7] = htmlPreviewImageUrl;
    $[8] = imageObjectPosition;
    $[9] = imageScale;
    $[10] = isCompetitionDrop;
    $[11] = loadStrategy;
    $[12] = media_mime_type;
    $[13] = media_url;
    $[14] = onContainerClick;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
}